import { SiteDraft, TenantSiteDraft, UpdateTenantSiteDraftResponse } from '../../../sitePublishing/types';

export type DraftWorkspaceState = {
  localDraft?: SiteDraft;
  draftVersion?: number;
  hasUnsavedChanges: boolean;
  keptConflictCopy: boolean;
};

export type SiteDraftUpdate = SiteDraft | ((current: SiteDraft) => SiteDraft);

export const emptyDraftWorkspaceState = (): DraftWorkspaceState => ({
  hasUnsavedChanges: false,
  keptConflictCopy: false,
});

export const initializeDraftWorkspace = (
  state: DraftWorkspaceState,
  serverDraft: TenantSiteDraft
): DraftWorkspaceState => state.localDraft ? state : {
  localDraft: serverDraft.content,
  draftVersion: serverDraft.draftVersion,
  hasUnsavedChanges: false,
  keptConflictCopy: false,
};

export const editDraftWorkspace = (
  state: DraftWorkspaceState,
  localDraft: SiteDraft
): DraftWorkspaceState => ({
  ...state,
  localDraft,
  hasUnsavedChanges: true,
  keptConflictCopy: false,
});

export const updateDraftWorkspace = (
  state: DraftWorkspaceState,
  update: SiteDraftUpdate
): DraftWorkspaceState => {
  if (!state.localDraft) return state;
  const localDraft = typeof update === 'function' ? update(state.localDraft) : update;
  return editDraftWorkspace(state, localDraft);
};

export const replaceGalleryImageAtIndex = (
  draft: SiteDraft,
  index: number,
  expectedImage: string | undefined,
  replacementImage: string
): SiteDraft => {
  if (!expectedImage || draft.homepage.gallery[index]?.image !== expectedImage) return draft;
  const gallery = draft.homepage.gallery.map((item, itemIndex) =>
    itemIndex === index ? {...item, image: replacementImage} : item);
  return {
    ...draft,
    homepage: {...draft.homepage, gallery},
  };
};

export const completeDraftSave = (
  state: DraftWorkspaceState,
  response: UpdateTenantSiteDraftResponse
): DraftWorkspaceState => ({
  ...state,
  draftVersion: response.draftVersion,
  hasUnsavedChanges: false,
  keptConflictCopy: false,
});

export const keepConflictingDraft = (state: DraftWorkspaceState): DraftWorkspaceState => ({
  ...state,
  keptConflictCopy: true,
  hasUnsavedChanges: true,
});

export const reloadDraftWorkspace = (serverDraft: TenantSiteDraft): DraftWorkspaceState => ({
  localDraft: serverDraft.content,
  draftVersion: serverDraft.draftVersion,
  hasUnsavedChanges: false,
  keptConflictCopy: false,
});
